export enum BannerTypes {
  ACCEPTED = 'accepted',
  DATA_AVAILABLE = 'available',
  IN_REVIEW = 'inReview',
  SUBMISSION_CLOSED = 'submission_closed',
  VALIDATION_OPEN = 'validation_open',
}
